import useAuth from "./useAuth";

const useGuard = () => {
  const { isSignedIn } = useAuth();

  return isSignedIn;
};

export default useGuard;
